import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import {
  components as components14Absorption,
  extraContent as extraContent14Absorption,
} from "./components/14-absorption";
import {
  components as components25Absorption,
  extraContent as extraContent25Absorption,
} from "./components/25-absorption";

const principle: Slide = {
  description:
    "In this section, the benefits of binaural unmasking are demonstrated for a situation including a target speaker and three background conversations. You can switch between mono playback (left channel or right channel on both ears) and binaural playback. The binaural unmasking effect is subtle and noticable, and it varies for different room acoustic conditions.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "14% absorption" }, { name: "25% absorption" }],
          options: {
            label: "Absorption 500-2000Hz",
            labelPosition: "top",
          },
        },
      ],
      extraContent: [extraContent14Absorption, extraContent25Absorption],
      components: [components14Absorption, components25Absorption],
    },
  },
};

export default principle;
